// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.gallery {
  box-sizing: border-box;
  min-height: var(--content-height);
  padding: 1.25rem 1.5rem 2.5rem;
}

.galleryIntro {
  text-align: center;
  margin: 0 0 1.4rem;
}

.galleryIntro h1 {
  margin: 0.15rem 0 0.25rem;
}

.galleryStatus {
  text-align: center;
  margin: 1.5rem 0;
}

.galleryGrid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(16.5rem, 1fr));
  gap: 1.35rem;
}

.galleryCard {
  background: var(--white);
  border-radius: var(--card-radius);
  padding: 1rem 1rem 0.85rem;
  box-shadow: var(--shadow-card);
  min-width: 0;
}

.galleryPrompt {
  font-family: var(--font-heading);
  font-size: 1.15rem;
  line-height: 1.25;
  margin: 0 0 0.3rem;
}

.galleryResponse {
  font-size: 0.95rem;
  line-height: 1.35;
  color: var(--ink-soft);
  margin: 0 0 0.75rem;
}

.galleryService {
  margin: 0.15rem 0 0;
  font-size: 0.78rem;
  text-align: center;
  line-height: 1.3;
}

@media (max-width: 600px) {
  .gallery {
    padding: 1rem 0.85rem 2rem;
  }

  .galleryGrid {
    grid-template-columns: 1fr;
  }
}
`, "",{"version":3,"sources":["webpack://./src/browser/webapp/components/gallery/gallery.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,iCAAiC;EACjC,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8DAA8D;EAC9D,YAAY;AACd;;AAEA;EACE,wBAAwB;EACxB,iCAAiC;EACjC,0BAA0B;EAC1B,8BAA8B;EAC9B,YAAY;AACd;;AAEA;EACE,gCAAgC;EAChC,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;AACF","sourcesContent":[".gallery {\n  box-sizing: border-box;\n  min-height: var(--content-height);\n  padding: 1.25rem 1.5rem 2.5rem;\n}\n\n.galleryIntro {\n  text-align: center;\n  margin: 0 0 1.4rem;\n}\n\n.galleryIntro h1 {\n  margin: 0.15rem 0 0.25rem;\n}\n\n.galleryStatus {\n  text-align: center;\n  margin: 1.5rem 0;\n}\n\n.galleryGrid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(16.5rem, 1fr));\n  gap: 1.35rem;\n}\n\n.galleryCard {\n  background: var(--white);\n  border-radius: var(--card-radius);\n  padding: 1rem 1rem 0.85rem;\n  box-shadow: var(--shadow-card);\n  min-width: 0;\n}\n\n.galleryPrompt {\n  font-family: var(--font-heading);\n  font-size: 1.15rem;\n  line-height: 1.25;\n  margin: 0 0 0.3rem;\n}\n\n.galleryResponse {\n  font-size: 0.95rem;\n  line-height: 1.35;\n  color: var(--ink-soft);\n  margin: 0 0 0.75rem;\n}\n\n.galleryService {\n  margin: 0.15rem 0 0;\n  font-size: 0.78rem;\n  text-align: center;\n  line-height: 1.3;\n}\n\n@media (max-width: 600px) {\n  .gallery {\n    padding: 1rem 0.85rem 2rem;\n  }\n\n  .galleryGrid {\n    grid-template-columns: 1fr;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
